
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnDestroy,
  ChangeDetectionStrategy
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, of, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AdminService } from '../../../shared/services/admin.service';
import { AppService } from '../../../shared/services/api/app.service';
import { AssetsService } from '../../../shared/services/assets.service';
import { AdminScoutInstallation, ScoutContent } from '../../../shared';
import { Notes } from '../../../shared/interfaces/notes';
@Component({
    selector: 'app-scouts-edit',
    templateUrl: './scouts-edit.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScoutsEditComponent implements OnInit, OnDestroy {
  @Output() selectEmitt = new EventEmitter();
  @Input() scout: any;
  scoutInitState: any;
  event: EventEmitter<any> = new EventEmitter();
  scoutId = '';
  hasAssets = true;
  loading = true;
  scouts: any[] = [];
  scoutdata;
  appScouts: any[] = [];
  appSensors: any[] = [];
  title = "";
  toolTip = "";
  intervalChanged = false;
  firmwareVersion: string = "";
  installs: AdminScoutInstallation[] = [];
  coordinates: any[] = [];
  notes: Notes[] = [];
  _sendInterval: number;
  _pollInterval: number;
  scoutSubscription: Subscription;
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    public _dialog: MatDialog,
    private _adminService: AdminService,
    private _assetService: AssetsService,
    private _appService: AppService
  ) {
    this.toolTip =
      "Configure or edit scout details.";
  }

  get sendInterval(): number {
    return this._sendInterval;
  }
  set sendInterval(sendInterval: number) {
    if (this._sendInterval !== sendInterval) {
      this._sendInterval = sendInterval;
      this.intervalChanged = true;
    }
  }

  get pollInterval(): number {
    return this._pollInterval;
  }

  set pollInterval(pollInterval: number) {
    if (this._pollInterval !== pollInterval) {
      this._pollInterval = pollInterval;
      this.intervalChanged = true;
    }
  }

  ngOnInit() {
    this._route.paramMap.pipe(
      map(params => {
        const id = params.get('id');
        this.scoutId = id;
        return id;
      }),
      mergeMap(id => {
        const getAppScout = this._appService.getTableScout(id);
        const getAppSensorById = this._appService.getAppSensorById(id);
        const getScoutData = this._adminService.getAppScout();
        const getNotes = this._adminService.getNotesByEntityCodeOrIdSecondary(null, this.scoutId)
          .pipe(catchError((err) => of(undefined)));
        return forkJoin([
          getAppScout,
          getAppSensorById,
          getScoutData,
          getNotes
        ]);
      })).subscribe(results => {
        const appScouts = results[0];
        const appSensors = results[1];
        const scoutData = results[2];
        const notes = results[3];
        
        this.notes = notes;
        this.scout = appScouts;
        if (this.scout) {
          this.loading = false;
        }
        this.appSensors = appSensors;
        this.title = `${this.scout.basicName} Scout Details`;

        this.scoutdata = scoutData;

        this.scoutdata = this.findScoutData(scoutData);

        this.firmwareVersion = this.scoutdata.firmwareModelInfo.version;

        if (this.scoutdata != null && this.scoutdata['coordinateLongitude']) {
          this.coordinates = [this.scoutdata['coordinateLatitude'], this.scoutdata['coordinateLongitude']]
          console.log('coordinates: ' + this.coordinates)
        }
        console.log(this.scoutdata);

        this.getIntervals()
        this.loading = false;
      })
  }

  ngOnDestroy() {
    if (this.scoutSubscription) {
      this.scoutSubscription.unsubscribe();
    }
    if (this._dialog) {
      this._dialog.ngOnDestroy();
    }
  }

  navigateToHealth(id: string) {
    this._router.navigate([`/assets/${id}`])
  }

  navigateToAsset(id: string) {
    this._router.navigate([`/assets/${id}`])
  }

  navigateToFirmware(id: string) {
    this._router.navigate([`/firmwares`])
  }

  findScoutModel(scouts, id: string) {
    let s;
    for (let i = 0; i < scouts.length; i++) {
      const scout = scouts[i];
      if (scout.id === id) {
        s = scout;
      }
    }
    return s;
  }

  findScoutData(scouts: any[]) {
    let s;
    for (let i = 0; i < scouts.length; i++) {
      const scout = scouts[i];
      if (scout.code === this.scout.code) {
        s = scout;
      }
    }

    return s;
  }

  noteAdded($event) {
    if ($event) {
      this._adminService.getNotesByEntityCodeOrIdSecondary(null, this.scoutId).subscribe(result => {
        this.notes = result;
      })
    }
  }

  getIntervals() {
    this.loading = true;
    this.scoutSubscription = this._assetService.getScoutTable(this.scoutId)
      .subscribe(resp => {
        this.scout = resp;
        this._sendInterval = this.parseContentField(resp, 1);
        this._pollInterval = this.parseContentField(resp, 0);
      });
  }

  parseContentField(scout: ScoutContent, index: number): number {
    if (scout.content !== null || scout.content !== undefined) {
      const parsed = scout.content.split(',');
      const converted = parseInt(parsed[index]);
      return converted;
    }
  }
}

export interface ScoutTree {
  assetCode: string;
  assetId: string;
  assetModelInfo: {
    assetKindCodes: string;
    capabilities: any[],
    id: string,
    code: string,
    name: string
  }
  assetName: string;
  assetOwnershipId: string;
  assetScoutKind: number;
  baseScoutId: string;
  code: string;
  connectivityBaseScoutCode: string;
  connectivityCode: string;
  content: string;
  coordinateAltitude: number;
  coordinateLatitude: number;
  coordinateLongitude: number;
  description: string;
  firmwareModelInfo: {
    updateInfo: string;
    version: string;
    description: string;
    name: string;
    id: string;
  }
  healthSensorId: string;
  holdingId: string;
  id: string;
  name: string;
  notificationConfirmationCount: number;
  sensors: any[];
  statistic: any[]
}